import React from "react";

const RecentActivities = () => {
  // Dummy data for recent activities
  const activities = [
    { description: "Posted a new job: Software Engineer", timestamp: "10:30 AM, Today" },
    { description: "Reviewed 15 applications for Data Analyst", timestamp: "9:15 AM, Today" },
    { description: "Scheduled interviews for Marketing Manager", timestamp: "Yesterday, 3:45 PM" },
    { description: "Sent offer letters to 5 candidates", timestamp: "Yesterday, 12:30 PM" },
    { description: "Updated the company profile", timestamp: "2 days ago, 11:00 AM" },
  ];

  return (
    <div className=" p-6 rounded-lg shadow-lg mt-6">
      <h2 className="text-2xl font-bold text-dark">Recent Activities</h2>
      <ul className="mt-4 space-y-4">
        {activities.map((activity, index) => (
          <li
            key={index}
            className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white p-4 rounded-md shadow-md hover:shadow-lg transition-shadow border border-gray-200"
          >
            <span className="text-gray-800 font-semibold mb-2 sm:mb-0">
              {activity.description}
            </span>
            <span className="text-gray-600 text-sm">{activity.timestamp}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentActivities;
